import React from 'react';
import { Plus } from 'react-feather';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import Card from '../ui/Card';

const BlankLessonCard = ({ onClick }) => {
  return (
    <div
      className="TemplateCard TemplateCard-hasImage"
      role="button"
      tabIndex="0"
      onClick={onClick}
      onKeyPress={e => e.key === 'Enter' && onClick()}
    >
      <Card.Content className="TemplateCard-content">
        <Text
          className="TemplateCard-title ws-pr"
          variant={TEXT_VARIANTS.BODY_BOLD}
        >
          {t('templates.gallery.blank_lesson')}
        </Text>
        <div className="TemplateCard-blankCardImage">
          <Plus color="rgba(148, 148, 153, 1)" strokeWidth="1.25" size="50" />
        </div>
      </Card.Content>
    </div>
  );
};

export default BlankLessonCard;
